import React from "react";
import "./SectorsSection.css";

const EngineeringTechnicalTrustSection = () => {
  const sectors = [
    "Corporate Office Buildings",
  "Industrial Facilities",
  "Manufacturing Plants",
  "IT Parks & Tech Centers",
  "Hospitals & Healthcare",
  "Educational Institutions",
  "Hotels & Hospitality",
  "Shopping Malls",
  "Commercial Complexes",
  "Warehouses",
  "Residential Societies",
  "Government Buildings"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EngineeringTechnicalTrustSection;
